module.exports = __webpack_public_path__ + "static/media/domicilio_blanco.972450f6.svg";